/* eslint-disable */
import generalConfig from '@/config'
import utils from '../utils'
import campaignConfig from '../components/views/Campaign/config'
import apiService from '../services/apiService'
const paymentServiceBaseURL = generalConfig.apiServiceBaseURL.payment // use of campaign service base url
const userRoles = generalConfig.userRoles
const bankAccounts = require('../components/views/User/bank_accounts.js')
const paymentStatus = campaignConfig.paymentStatus
const sectionIDs = campaignConfig.paymentConsSectionIDs
const getPaymentPlatform = infDetails => String((infDetails && (infDetails.platform || infDetails.activePlatform)) || '').toLowerCase()
import find from 'lodash/find'
import orderBy from 'lodash/orderBy';
import moment from 'moment'
const state = {
  status: {
    // NEW: {
    //   text: '-',
    //   value: 0,
    //   order: 1,
    //   color: '#2196f3',
    //   permissions: [
    //     // userRoles.SUPER_ADMIN_HIGH,
    //     // userRoles.SUPER_ADMIN_LOW,
    //     // userRoles.COMPANY_ADMIN_HIGH,
    //     // userRoles.COMPANY_ADMIN_LOW,
    //     // userRoles.AD_STRATEGIST,
    //     // userRoles.ACCOUNT_MANAGER,
    //     // userRoles.FINANCE
    //   ],
    //   allowedStatusChange: []
    // },
    PAID: {
      text: 'Paid',
      value: 1,
      order: 7,
      color: '#2f7d46',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      allowedStatusChange: [
        campaignConfig.paymentStatus.PARTIAL,
        campaignConfig.paymentStatus.APPROVAL_LEAD
      ]
    },
    // UNPAID: {
    //   text: 'UnPaid',
    //   value: 2,
    //   order: 8,
    //   color: '#ff5252',
    //   permissions: [
    //     userRoles.SUPER_ADMIN_HIGH,
    //     userRoles.SUPER_ADMIN_LOW,
    //     userRoles.FINANCE
    //   ],
    //   allowedStatusChange: [
    //     campaignConfig.paymentStatus.PAID
    //   ]
    // },
    PROCESSING: {
      text: 'Pre-processing',
      value: 3,
      order: 2,
      color: '#b77900',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.FINANCE
      ],
      allowedStatusChange: [
        campaignConfig.paymentStatus.PARTIAL
      ]
    },
    // ERROR: {
    //   text: 'Error',
    //   value: 4,
    //   order: 9,
    //   color: '#ff5252',
    //   permissions: [
    //     userRoles.SUPER_ADMIN_HIGH,
    //     userRoles.SUPER_ADMIN_LOW,
    //     userRoles.FINANCE
    //   ],
    //   allowedStatusChange: [
    //     campaignConfig.paymentStatus.PAID,
    //     campaignConfig.paymentStatus.APPROVAL_LEAD
    //   ]
    // },
    PARTIAL: {
      text: 'WIP by Finance',
      value: 5,
      order: 6,
      color: '#3f3fff',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      allowedStatusChange: [
        campaignConfig.paymentStatus.APPROVAL_FINANCE
      ]
    },
    APPROVAL_FINANCE: {
      text: 'Approval by Finance',
      value: 6,
      order: 3,
      color: '#3f3fff',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.FINANCE
      ],
      allowedStatusChange: [
        campaignConfig.paymentStatus.PROCESSING,
        campaignConfig.paymentStatus.PARTIAL
      ]
    }
    // APPROVAL_LEAD: {
    //   text: 'Approval by Lead',
    //   value: 7,
    //   order: 5,
    //   color: '#4CAF50',
    //   permissions: [
    //     userRoles.SUPER_ADMIN_HIGH,
    //     userRoles.SUPER_ADMIN_LOW,
    //     userRoles.FINANCE
    //   ],
    //   allowedStatusChange: [
    //     campaignConfig.paymentStatus.APPROVAL_FINANCE
    //   ]
    // }
    // RELEASED_FINANCE: {
    //   text: 'Release to Lead for approval',
    //   value: 8,
    //   order: 4,
    //   permissions: [
    //     userRoles.SUPER_ADMIN_HIGH,
    //     userRoles.SUPER_ADMIN_LOW,
    //     userRoles.AD_STRATEGIST
    //   ],
    //   allowedStatusChange: [
    //     campaignConfig.paymentStatus.APPROVAL_FINANCE
    //   ]
    // }
  },
  paymentUpdateFields: [
    {
      name: 'PVNumber',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      status: [
        campaignConfig.paymentStatus.PARTIAL
      ]
    },
    {
      name: 'bankReference',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      status: [
        campaignConfig.paymentStatus.PAID
      ]
    },
    {
      name: 'paymentDate',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      status: [
        campaignConfig.paymentStatus.PAID
      ]
    },
    {
      name: 'submissionDate',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ],
      status: []
    },
    {
      name: 'batch',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      status: [
        campaignConfig.paymentStatus.PAID
      ]
    },
    {
      name: 'paymentStatus',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE,
        userRoles.AD_STRATEGIST
      ],
      status: [
        campaignConfig.paymentStatus.PROCESSING,
        campaignConfig.paymentStatus.PAID,
        campaignConfig.paymentStatus.UNPAID,
        campaignConfig.paymentStatus.ERROR,
        campaignConfig.paymentStatus.PARTIAL,
        campaignConfig.paymentStatus.APPROVAL_FINANCE,
        campaignConfig.paymentStatus.APPROVAL_LEAD,
        campaignConfig.paymentStatus.RELEASED_FINANCE
      ]
    },
    {
      name: 'actualAmount',
      permissions: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ],
      status: [
        campaignConfig.paymentStatus.PAID
      ]
    }
  ],
  bankSwiftCodes: bankAccounts,
  exportTypes: campaignConfig.paymentConsExportTypes,
  tableEditFields: [
    {
      name: 'bankReference',
      batchNo: [sectionIDs.WIP_FINANCE, sectionIDs.PAID]
    },
    {
      name: 'paymentDate',
      batchNo: [sectionIDs.WIP_FINANCE, sectionIDs.PAID]
    },
    {
      name: 'PVNumber',
      batchNo: [sectionIDs.APPROVAL_FINANCE]
    }
  ],
  filtersStates: [
    {
      name: 'liveDate',
      batchNo: [
        sectionIDs.IMPORTED,
        sectionIDs.BATCH_ONE,
        sectionIDs.BATCH_TWO,
        sectionIDs.APPROVAL_FINANCE,
        sectionIDs.APPROVAL_LEAD,
        sectionIDs.WIP_FINANCE
      ]
    },
    {
      name: 'dueDate',
      batchNo: [
        sectionIDs.IMPORTED,
        sectionIDs.BATCH_ONE,
        sectionIDs.BATCH_TWO,
        sectionIDs.APPROVAL_FINANCE,
        sectionIDs.APPROVAL_LEAD,
        sectionIDs.WIP_FINANCE
      ]
    },
    {
      name: 'paymentDate',
      batchNo: [
        sectionIDs.PAID
      ]
    }
  ],
  sectionsByRoles: {
    CC: [
      sectionIDs.IMPORTED,
      sectionIDs.BATCH_ONE,
      sectionIDs.BATCH_TWO
    ],
    FINANCE: [
      sectionIDs.BATCH_ONE,
      sectionIDs.BATCH_TWO,
      sectionIDs.APPROVAL_FINANCE,
      sectionIDs.APPROVAL_LEAD,
      sectionIDs.WIP_FINANCE,
      sectionIDs.PAID
    ]
  },
  financePayments: [],
  preProcessingPayments: [],
  importedPayments: [],
  completedPayments: [],
  savedCompletedPayments: false,
  savedFinancePayments: false,
  saved: false,
  creatorCogsEstimate: [],
  profitSummary: []
}

const getters = {
  status: state => state.status,
  paymentStatusOptions: (state) => {
    let data = [];
    Object.entries(state.status).forEach(item => {
      data.push({
        status: item[1].value,
        display: item[1].text,
        order: item[1].order,
        permissions: item[1].permissions,
        allowedStatusChange: item[1].allowedStatusChange
      });
    });
    data = Object.assign([], data).sort((a, b) => a.order - b.order);
    return data;
  },
  allowedStatuses: (state, getters, rootState, rootGetters) => {
    let userRole = Number(rootState.user.role)
    let filtered = getters.paymentStatusOptions.filter(option => option.permissions.includes(userRole))
    return filtered
  },
  allowedStatusesForPayoutCreate: (state, getters, rootState, rootGetters) => {
    let userRole = Number(rootState.user.role)
    let filtered = getters.paymentStatusOptions
    if (userRole !== userRoles.SUPER_ADMIN_HIGH) {
      filtered = getters.paymentStatusOptions.filter(option => option.status === campaignConfig.paymentStatus.PROCESSING)
    }
    return filtered
  },
  allowTableFieldEdit: (state, getters, rootState, rootGetters) => (fieldName, batchNo) => {
    if (batchNo === sectionIDs.PAID || getters.currentUserRole === userRoles.ACCOUNT_MANAGER) return false // if completed stage or AM Role, disallowed
    const matchField = state.tableEditFields.find(field => field.name === fieldName)
    if (!matchField) return true // if there is no match field, allowed
    if (matchField.batchNo.includes(batchNo)) return true // if match field exists, allowed
    return false // if no match field, disallowed
  },
  allowFilters: (state) => (fieldName, batchNo) => {
    const matchField = state.filtersStates.find(field => field.name === fieldName)
    if (!matchField) return true // if there is no match field, allowed
    if (matchField.batchNo.includes(batchNo)) return true // if match field exists, allowed
    return false // if no match field, disallowed
  },
  allowedActions: (state, getters, rootState, rootGetters) => (actionName) => {
    let userRole = Number(rootState.user.role)
    if (userRole === userRoles.AD_STRATEGIST) {
      if (state.sectionsByRoles.CC.includes(actionName)) {
        return true
      }
    } else if (userRole === userRoles.FINANCE) {
      if (state.sectionsByRoles.FINANCE.includes(actionName)) {
        return true
      }
    } else if (userRole === userRoles.ACCOUNT_MANAGER) {
      return false
    } else {
      return true
    }
    return false
  },
  getPaymentStatus: (state) => (statusVal) => {
    let statusText = '-'
    Object.entries(state.status).forEach(item => {
      if (statusVal === item[1].value) {
        statusText = item[1].text
      }
    });
    return statusText
  },
  getPaymentStatusObj: (state) => (statusVal) => {
    let statusObj = {}
    Object.entries(state.status).forEach(item => {
      if (statusVal === item[1].value) {
        statusObj = item[1]
      }
    });
    return statusObj
  },
  getPaymentConsolidationStatusValue: (state) => (payment) => {
    return Number(payment ? (payment.payment_status || payment.paymentStatus || payment.status) : null)
  },
  getPaymentConsolidationRecordHandles: (state) => (payment) => {
    if (!payment) return []
    let handles = []
    if (payment.influencer_details) {
      handles.push(payment.influencer_details.handle)
      handles.push(payment.influencer_details.instagramHandle)
      handles.push(payment.influencer_details.linkedinHandle)
      handles.push(payment.influencer_details.userHandle)
      handles.push(payment.influencer_details.username)
      handles.push(payment.influencer_details.fullName)
    }
    handles.push(payment.instagram)
    handles.push(payment.handle)
    handles.push(payment.username)
    handles.push(payment.fullName)
    return [...new Set(handles.filter(Boolean).map(handle => String(handle).trim().toLowerCase()))]
  },
  getPaymentConsolidationRecordInfluencerID: (state) => (payment) => {
    if (!payment) return ''
    if (payment.influencer_details && payment.influencer_details.influencerID) {
      return payment.influencer_details.influencerID
    }
    return payment.influencerID || ''
  },
  // An influencer can have multiple connected platform handles (e.g. a secondary IG account);
  // content/payment records may be attributed to whichever handle posted, so influencerID -
  // stable across all of an influencer's handles - is checked before falling back to handle.
  isPaymentConsolidationRecordMatch: (state, getters) => (payment, campaignID, handle, influencerID, pairingID) => {
    if (!payment || !payment.campaign || !payment.influencer_details) return false
    const paymentCampaignID = payment.campaign.id || payment.campaignID
    if (paymentCampaignID !== campaignID) return false
    if (pairingID && payment.pairingID && payment.pairingID === pairingID) return true
    const paymentInfluencerID = getters.getPaymentConsolidationRecordInfluencerID(payment)
    if (influencerID && paymentInfluencerID && paymentInfluencerID === influencerID) return true
    const normalizedHandle = handle ? String(handle).trim().toLowerCase() : ''
    const paymentHandles = getters.getPaymentConsolidationRecordHandles(payment)
    return paymentHandles.includes(normalizedHandle)
  },
  isPaymentConsolidationCommittedRecord: (state, getters) => (payment) => {
    const statusValue = getters.getPaymentConsolidationStatusValue(payment)
    if (statusValue === paymentStatus.PROCESSING) return !!(payment && payment.imported)
    return statusValue === paymentStatus.PARTIAL ||
      statusValue === paymentStatus.APPROVAL_FINANCE ||
      statusValue === paymentStatus.PAID
  },
  getPaymentConsolidationRecordAmount: (state) => (payment) => {
    if (payment && payment.transaction_details) {
      return Number(payment.transaction_details.amount || 0)
    }
    return Number(payment && payment.amount ? payment.amount : 0)
  },
  getPaymentConsolidationCommittedAmount: (state, getters) => (payments, campaignID, handle, influencerID, pairingID) => {
    return payments
      .filter(payment => getters.isPaymentConsolidationRecordMatch(payment, campaignID, handle, influencerID, pairingID) &&
        getters.isPaymentConsolidationCommittedRecord(payment))
      .map(payment => getters.getPaymentConsolidationRecordAmount(payment))
      .reduce((total, amount) => total + amount, 0)
  },
  getPaymentConsolidationBalanceAmount: (state, getters) => (pairedAmount, payments, campaignID, handle, influencerID, pairingID) => {
    if (pairedAmount === undefined || pairedAmount === null || pairedAmount === '') return null
    const committedAmount = getters.getPaymentConsolidationCommittedAmount(payments, campaignID, handle, influencerID, pairingID)
    const remainingAmount = Number(pairedAmount || 0) - Number(committedAmount || 0)
    return Math.max(remainingAmount, 0).toFixed(2)
  },
  getPaymentConsolidationStatusDisplay: (state, getters) => (payments, campaignID, handle, influencerID, pairingID) => {
    return payments
      .filter(payment => getters.isPaymentConsolidationRecordMatch(payment, campaignID, handle, influencerID, pairingID))
      .map(payment => {
        let amount = getters.getPaymentConsolidationRecordAmount(payment)
        const statusValue = getters.getPaymentConsolidationStatusValue(payment)
        if (statusValue === paymentStatus.PROCESSING && !(payment && payment.imported)) {
          let pairedAmount = payment && payment.transaction_details
            ? Number(payment.transaction_details.pairedAmount)
            : Number(payment && payment.pairedAmount)
          if (isNaN(pairedAmount)) pairedAmount = amount
          const committedAmount = getters.getPaymentConsolidationCommittedAmount(payments, campaignID, handle, influencerID, pairingID)
          amount = Math.max(Number(pairedAmount || 0) - Number(committedAmount || 0), 0)
        }
        const currency = payment.currency || 'SGD'
        let ret = {
          currency,
          payConsAmt: amount.toFixed(2),
          statusDisplay: getters.getPaymentStatusObj(getters.getPaymentConsolidationStatusValue(payment))
        }
        if (payment.imported) {
          ret.imported = true
        }
        if (currency !== 'SGD') {
          ret.sgdAmt = utils.func.convertCurrency(currency, amount, state.currencyRates)
        }
        return ret
      })
      .filter(payment => payment.payConsAmt)
  },
  currentUserID: (state, getters, rootState, rootGetters) => {
    return rootState.user.id
  },
  currentUserRole: (state, getters, rootState, rootGetters) => {
    return Number(rootState.user.role)
  },
  formatPosts: (state, getters, rootState, rootGetters) => (posts, sections, users, filters = {}) => {
    posts = Object.assign([], posts).sort((a, b) => a.lineUpIndex - b.lineUpIndex);
    if (filters.POC) {
      posts = posts.filter(p => {
        if (!p.POC || (p.POC && find(p.POC, { id: getters.currentUserID }))) return true
        return false
      })
    }
    for (let element of posts) {
      if (!element.PVNumber && element.VDNumber) {
        // fix for using old field VDNumber
        element.PVNumber = element.VDNumber
      }
      // if (element.POC) {
      //   element.POCDisplay = utils.func.refreshJSON(element.POC)
      //   element.POCDisplay = element.POCDisplay.map(p => {
      //     let user = users.find(u => u.id === p.id)
      //     if (user) p.name = user.name
      //     return p
      //   })
      //   element.POCDisplay = element.POCDisplay.map(p => p.name).join(', ')
      // }
      if ((element.status === paymentStatus.PAID
        || element.status === paymentStatus.APPROVAL_FINANCE
        || element.status === paymentStatus.PARTIAL) && element.CC) {
        // set assigned To for completed payments from POC
        element.assignedTo = element.CC.map(p => p.id)
      }
      if (element.assignedTo) {
        // replace POC users with assigned To CC Users
        element.POCDisplay = utils.func.refreshJSON(element.POC)
        element.POCDisplay = element.assignedTo.map(p => {
          let user = users.find(u => u.id === p)
          let resp = {
            id: p
          }
          if (user) {
            resp.name = user.name
          }
          return resp
        })
        element.CC = element.POCDisplay.filter(p => p.name)
        element.POCDisplay = element.CC.map(p => p.name).join(', ')
      }
      element.paymentDate = getters.formatDate(element.paymentDate)
      element = getters.setDefaultEditFields(element)
      let sectionRets = getters.setBatchSectionsData(element, sections)
      element = sectionRets.element
      sections = sectionRets.sections
      // if (!element.archive) {
      //   element = this.setBatchSectionsData(element, sections)
      // }
      // if (!element.imported) {
      element.liveDate = getters.formatDate(element.liveDate)
      element.overdue = getters.checkOverDue(element.dueDate)
      element.early = getters.checkEarly(element.dueDate)
      element.dueDate = getters.formatDate(element.dueDate)
      // }
      if (element.partialAmount.length > 0 || element.importedAmount) {
        element.paidAmount = getters.getPaidAmount(element)
        element.amount = getters.getRemainAmount(element)
      }
      if (element.currency) {
        if (element.currency !== 'SGD') {
          element.sgdAmt = utils.func.convertCurrency(element.currency, element.amount, state.currencyRates)
        }
      }
    }
    // sort by live date for batch 1, 2
    sections.batchOne = getters.getSortedLiveDates(sections.batchOne)
    sections.batchTwo = getters.getSortedLiveDates(sections.batchTwo)
    return {
      posts,
      sections
    }
  },
  formatPreProcessingPayments: (state, getters, rootState, rootGetters) => (users, invoiceLists) => {
    // format pre-processing payments according to payment consolidation table header
    let formattedPayments = []
    for (let element of state.preProcessingPayments) {
      let infDetails = element.influencer_details
      let deliverables = element.deliverables
      let campaign = element.campaign
      let transDetails = element.transaction_details
      let invoices = element.invoices
      // inf information
      element.instagram = infDetails.handle || ''
      element.platformHandlesObj = element.platformHandlesObj
      const paymentPlatform = getPaymentPlatform(infDetails)
      element.platform = paymentPlatform
      if (paymentPlatform === 'tiktok') {
        element.isTikTok = true
      } else if (paymentPlatform === 'youtube') {
        element.isYoutube = true
      } else if (paymentPlatform === 'xiaohongshu') {
        element.isXHS = true
      } else if (paymentPlatform === 'facebook') {
        element.isFacebook = true
      }
      element.swiftCode = infDetails.swiftCode || ''
      element.bankName = infDetails.bankName || ''
      element.bankAccount = infDetails.bankAccount || ''
      element.username = infDetails.username || ''
      element.country = infDetails.country || ''
      element.fullName = infDetails.fullName || ''
      element.email = infDetails.email || ''
      if (infDetails.xhsID) {
        element.xhsID = infDetails.xhsID || ''
      }
      // deliverables
      element.agreedDeliverables = deliverables.agreed
      element.deliverables = deliverables.produced
      // campaign info
      element.clientName = campaign.clientName || ''
      element.campaignID = campaign.id || ''
      element.campaignName = campaign.name || ''
      element.IONumber = campaign.IONumber || ''
      // payment information
      element.PVNumber = transDetails.PVNumber || ''
      element.bankReference = transDetails.bankReference || ''
      element.GSTPercent = transDetails.GSTPercent || null
      element.specialPayment = transDetails.specialPayment || ''
      element.currency = transDetails.currency || 'SGD'
      element.pairedAmount = transDetails.pairedAmount || ''
      element.amount = transDetails.amount || ''
      element.remainAmount = transDetails.remainAmount || ''
      element.actualAmount = transDetails.actualAmount || ''
      element.partialAmount = []
      element.paymentDate = transDetails.paymentDate || ''
      element.paymentSubmissionDate = transDetails.submissionDate || ''
      element.payment_status = element.status
      element.paymentStatus = element.status
      // invoice info
      element.invoice = invoices.internalInvoice
      element.uploadInvoice = getters.getReportInvoices(element, invoiceLists)
      element.paymentInvoices = invoices.uploadInvoice || []
      if (element.CC) {
        // replace POC users with assigned To CC Users
        element.POCDisplay = utils.func.refreshJSON(element.POC)
        element.POCDisplay = element.CC.map(p => {
          let userID = null
          if (p.id) {
            userID = p.id
          } else {
            userID = p
          }
          let user = users.find(u => u.id === userID)
          let resp = {
            id: userID
          }
          if (user) {
            resp.name = user.name
          }
          return resp
        })
        element.POCDisplay = element.POCDisplay.map(p => p.name).join(', ')
      }
      // date info
      // element.liveDate = element.liveDate ? utils.func.parseDate(element.liveDate) : ''
      // element.dueDate = element.dueDate ? utils.func.parseDate(element.dueDate) : ''
      formattedPayments.push(element)
    }
    return formattedPayments
  },
  getReportInvoices: (state, getters, rootState, rootGetters) => (report, reportInvoices = []) => {
    let matchInvoices = []
    let datas = reportInvoices.filter(inv => inv.handle === report.instagram)
    if (datas && datas.length) {
      for (let data of datas) {
        if (data.invoice) {
          if (typeof data.invoice === 'string') {
            matchInvoices.push({
              id: data.id,
              url: data.invoice,
              timestamp: data.createdAt
            })
          } else {
            matchInvoices.push(Object.assign({}, data.invoice, {
              id: data.id,
              timestamp: data.invoice.timestamp || data.createdAt
            }))
          }
        }
      }
    }
    return matchInvoices
  },
  formatImportedPayments: (state, getters, rootState, rootGetters) => (users, invoiceLists) => {
    // format imported payments according to payment consolidation table header
    let formattedPayments = []
    for (let element of state.importedPayments) {
      let infDetails = element.influencer_details
      let deliverables = element.deliverables
      let campaign = element.campaign
      let transDetails = element.transaction_details
      let invoices = element.invoices
      // inf information
      element.instagram = infDetails.handle || ''
      element.platformHandlesObj = element.platformHandlesObj
      const paymentPlatform = getPaymentPlatform(infDetails)
      element.platform = paymentPlatform
      if (paymentPlatform === 'tiktok') {
        element.isTikTok = true
      } else if (paymentPlatform === 'youtube') {
        element.isYoutube = true
      } else if (paymentPlatform === 'xiaohongshu') {
        element.isXHS = true
      } else if (paymentPlatform === 'facebook') {
        element.isFacebook = true
      }
      element.swiftCode = infDetails.swiftCode || ''
      element.bankName = infDetails.bankName || ''
      element.bankAccount = infDetails.bankAccount || ''
      element.username = infDetails.username || ''
      element.country = infDetails.country || ''
      element.fullName = infDetails.fullName || ''
      element.email = infDetails.email || ''
      if (infDetails.xhsID) {
        element.xhsID = infDetails.xhsID || ''
      }
      // deliverables
      element.agreedDeliverables = deliverables.agreed
      element.deliverables = deliverables.produced
      // campaign info
      element.clientName = campaign.clientName || ''
      element.campaignID = campaign.id || ''
      element.campaignName = campaign.name || ''
      element.IONumber = campaign.IONumber || ''
      // payment information
      element.PVNumber = transDetails.PVNumber || ''
      element.bankReference = transDetails.bankReference || ''
      element.GSTPercent = transDetails.GSTPercent || null
      element.specialPayment = transDetails.specialPayment || ''
      element.currency = transDetails.currency || 'SGD'
      element.pairedAmount = transDetails.pairedAmount || ''
      element.amount = transDetails.amount || ''
      element.remainAmount = transDetails.remainAmount || ''
      element.actualAmount = transDetails.actualAmount || ''
      element.partialAmount = []
      element.paymentDate = transDetails.paymentDate || ''
      element.paymentSubmissionDate = transDetails.submissionDate || ''
      element.payment_status = element.status
      element.paymentStatus = element.status
      // invoice info
      element.invoice = invoices.internalInvoice
      // element.uploadInvoice = invoices.uploadInvoice
      element.uploadInvoice = getters.getReportInvoices(element, invoiceLists)
      element.paymentInvoices = invoices.uploadInvoice || []
      
      if (element.CC) {
        // replace POC users with assigned To CC Users
        element.POCDisplay = utils.func.refreshJSON(element.POC)
        element.POCDisplay = element.CC.map(p => {
          let userID = null
          if (p.id) {
            userID = p.id
          } else {
            userID = p
          }
          let user = users.find(u => u.id === userID)
          let resp = {
            id: userID
          }
          if (user) {
            resp.name = user.name
          }
          return resp
        })
        element.POCDisplay = element.POCDisplay.map(p => p.name).join(', ')
      }
      // date info
      // element.liveDate = element.liveDate ? utils.func.parseDate(element.liveDate) : ''
      // element.dueDate = element.dueDate ? utils.func.parseDate(element.dueDate) : ''
      formattedPayments.push(element)
    }
    return formattedPayments
  },
  formatFinancePayments: (state, getters, rootState, rootGetters) => (users, invoiceLists) => {
    // format finance payments according to payment consolidation table header
    let formattedPayments = []
    for (let element of state.financePayments) {
      let infDetails = element.influencer_details
      let deliverables = element.deliverables
      let campaign = element.campaign
      let transDetails = element.transaction_details
      let invoices = element.invoices
      // inf information
      element.instagram = infDetails.handle || ''
      element.platformHandlesObj = element.platformHandlesObj
      const paymentPlatform = getPaymentPlatform(infDetails)
      element.platform = paymentPlatform
      if (paymentPlatform === 'tiktok') {
        element.isTikTok = true
      } else if (paymentPlatform === 'youtube') {
        element.isYoutube = true
      } else if (paymentPlatform === 'xiaohongshu') {
        element.isXHS = true
      } else if (paymentPlatform === 'facebook') {
        element.isFacebook = true
      }
      element.swiftCode = infDetails.swiftCode || ''
      element.bankName = infDetails.bankName || ''
      element.bankAccount = infDetails.bankAccount || ''
      element.username = infDetails.username || ''
      element.country = infDetails.country || ''
      element.fullName = infDetails.fullName || ''
      element.email = infDetails.email || ''
      if (infDetails.xhsID) {
        element.xhsID = infDetails.xhsID || ''
      }
      // deliverables
      element.agreedDeliverables = deliverables.agreed
      element.deliverables = deliverables.produced
      // campaign info
      element.clientName = campaign.clientName || ''
      element.campaignID = campaign.id || ''
      element.campaignName = campaign.name || ''
      element.IONumber = campaign.IONumber || ''
      // payment information
      element.PVNumber = transDetails.PVNumber || ''
      element.bankReference = transDetails.bankReference || ''
      element.GSTPercent = transDetails.GSTPercent || null
      element.specialPayment = transDetails.specialPayment || ''
      element.currency = transDetails.currency || 'SGD'
      element.pairedAmount = transDetails.pairedAmount || ''
      element.amount = transDetails.amount || ''
      element.remainAmount = transDetails.remainAmount || ''
      element.actualAmount = transDetails.actualAmount || ''
      element.partialAmount = []
      element.paymentDate = transDetails.paymentDate || ''
      element.paymentSubmissionDate = transDetails.submissionDate || ''
      element.payment_status = element.status
      element.paymentStatus = element.status
      // invoice info
      element.invoice = invoices.internalInvoice
      element.uploadInvoice = getters.getReportInvoices(element, invoiceLists)
      element.paymentInvoices = invoices.uploadInvoice || []
      if (element.CC) {
        // replace POC users with assigned To CC Users
        element.POCDisplay = utils.func.refreshJSON(element.POC)
        element.POCDisplay = element.CC.map(p => {
          let userID = null
          if (p.id) {
            userID = p.id
          } else {
            userID = p
          }
          let user = users.find(u => u.id === userID)
          let resp = {
            id: userID
          }
          if (user) {
            resp.name = user.name
          }
          return resp
        })
        element.POCDisplay = element.POCDisplay.map(p => p.name).join(', ')
      }
      // date info
      // element.liveDate = element.liveDate ? utils.func.parseDate(element.liveDate) : ''
      // element.dueDate = element.dueDate ? utils.func.parseDate(element.dueDate) : ''
      formattedPayments.push(element)
    }
    return formattedPayments
  },
  formatCompletedPayments: (state, getters, rootState, rootGetters) => (users, invoiceLists) => {
    // format completed payments according to payment consolidation table header
    let formattedPayments = []
    for (let element of state.completedPayments) {
      let infDetails = element.influencer_details
      let deliverables = element.deliverables
      let campaign = element.campaign
      let transDetails = element.transaction_details
      let invoices = element.invoices
      // inf information
      element.instagram = infDetails.handle || ''
      element.platformHandlesObj = element.platformHandlesObj
      const paymentPlatform = getPaymentPlatform(infDetails)
      element.platform = paymentPlatform
      if (paymentPlatform === 'tiktok') {
        element.isTikTok = true
      } else if (paymentPlatform === 'youtube') {
        element.isYoutube = true
      } else if (paymentPlatform === 'xiaohongshu') {
        element.isXHS = true
      } else if (paymentPlatform === 'facebook') {
        element.isFacebook = true
      }
      element.swiftCode = infDetails.swiftCode || ''
      element.bankName = infDetails.bankName || ''
      element.bankAccount = infDetails.bankAccount || ''
      element.username = infDetails.username || ''
      element.country = infDetails.country || ''
      element.fullName = infDetails.fullName || ''
      element.email = infDetails.email || ''
      if (infDetails.xhsID) {
        element.xhsID = infDetails.xhsID || ''
      }
      // deliverables
      element.agreedDeliverables = deliverables.agreed
      element.deliverables = deliverables.produced
      // campaign info
      element.clientName = campaign.clientName || ''
      element.campaignID = campaign.id || ''
      element.campaignName = campaign.name || ''
      element.IONumber = campaign.IONumber || ''
      // payment information
      element.PVNumber = transDetails.PVNumber || ''
      element.bankReference = transDetails.bankReference || ''
      element.GSTPercent = transDetails.GSTPercent || null
      element.specialPayment = transDetails.specialPayment || ''
      element.currency = transDetails.currency || 'SGD'
      element.pairedAmount = transDetails.pairedAmount || ''
      element.amount = transDetails.amount || ''
      element.remainAmount = transDetails.remainAmount || ''
      element.actualAmount = transDetails.actualAmount || ''
      element.partialAmount = []
      element.paymentDate = transDetails.paymentDate || ''
      element.paymentSubmissionDate = transDetails.submissionDate || ''
      element.payment_status = element.status
      element.paymentStatus = element.status
      // invoice info
      element.invoice = invoices.internalInvoice
      element.uploadInvoice = getters.getReportInvoices(element, invoiceLists)
      element.paymentInvoices = invoices.uploadInvoice || []
      if (element.CC) {
        // replace POC users with assigned To CC Users
        element.POCDisplay = utils.func.refreshJSON(element.POC)
        element.POCDisplay = element.CC.map(p => {
          let userID = null
          if (p.id) {
            userID = p.id
          } else {
            userID = p
          }
          let user = users.find(u => u.id === userID)
          let resp = {
            id: userID
          }
          if (user) {
            resp.name = user.name
          }
          return resp
        })
        element.POCDisplay = element.POCDisplay.map(p => p.name).join(', ')
      }
      // date info
      // element.liveDate = element.liveDate ? utils.func.parseDate(element.liveDate) : ''
      // element.dueDate = element.dueDate ? utils.func.parseDate(element.dueDate) : ''
      formattedPayments.push(element)
    }
    return formattedPayments
  },
  setBatchTableSections: (state, getters, rootState, rootGetters) => (batches, headers, sections) => {
    for (let i = 1; i <= 7; i++) {
      batches.push(getters.getBatchTableData(i, headers, sections))
    }
  },
  getBatchTableData: (state, getters, rootState, rootGetters) => (id, headers, sections) => {
    let {name, batchNo, data, status, exportType} = getters.getBatchSectionsData(id, sections)
    let selectedPayments = []
    // if (this.oldBatches) {
    //   let batchOne = this.oldBatches.find(old => old.batchNo === batchNo)
    //   selectedPayments = Object.assign([], batchOne.selectedPayments)
    // }
    let customHeaders = []
    if (batchNo !== sectionIDs.WIP_FINANCE && batchNo !== sectionIDs.PAID) {
      customHeaders = headers.filter(h => h.value !== 'paymentDate' &&
      h.value !== 'paymentSubmissionDate' &&
      h.value !== 'bankReference')
    } else {
      customHeaders = Object.assign([], headers)
    }
    //
    if (batchNo !== sectionIDs.PAID) {
      customHeaders = customHeaders.filter(h => h.value !== 'batch')
    }
    //
    if (batchNo !== sectionIDs.APPROVAL_LEAD &&
      batchNo !== sectionIDs.WIP_FINANCE &&
      batchNo !== sectionIDs.PAID) {
      customHeaders = customHeaders.filter(h => h.value !== 'PVNumber')
    }
    //
    if (batchNo === sectionIDs.WIP_FINANCE) {
      customHeaders = customHeaders.filter(h => h.value !== 'bankReference' && h.value !== 'paymentDate')
    }
    //
    if (getters.currentUserRole === userRoles.ACCOUNT_MANAGER) {
      customHeaders = customHeaders.filter(h => h.value !== 'action')
    }
    return {
      id,
      name,
      batchNo,
      headers: customHeaders,
      displayData: data,
      data,
      disableSaveEdit: true,
      panel: [0],
      selectedPayments,
      filter: getters.searchParams(),
      status,
      totalAmount: 0,
      exportType
    }
  },
  setBatchSectionsData: (state, getters, rootState, rootGetters) => (element, sections) => {
    let status = element.payment_status
    // if paid, go to completed table
    if (status === paymentStatus.PAID) {
      element.batchNo = sectionIDs.PAID
      sections.completed.push(element)
    } else if (status === paymentStatus.PARTIAL) {
      element.batchNo = sectionIDs.WIP_FINANCE
      sections.partiallyPaid.push(element)
    } else if (status === paymentStatus.PROCESSING) {
      // if others, check imported and go to batches table
      if (element.imported) {
        element.batchNo = sectionIDs.IMPORTED
        sections.imported.push(element)
      } else {
        element.batchNo = element.liveDate ? getters.checkBatch(element.liveDate) : 'b1'
        if (element.batchNo === sectionIDs.BATCH_ONE) {
          sections.batchOne.push(element)
        }
        if (element.batchNo === sectionIDs.BATCH_TWO) {
          sections.batchTwo.push(element)
        }
      }
    } else if (status === paymentStatus.APPROVAL_FINANCE) {
      element.batchNo = sectionIDs.APPROVAL_FINANCE
      sections.approvalFinance.push(element)
    }
    // else if (status === paymentStatus.APPROVAL_LEAD) {
    //   element.batchNo = sectionIDs.APPROVAL_LEAD
    //   sections.approvalLead.push(element)
    // }
    return {
      element,
      sections
    }
  },
  getBatchSectionsData: (state, getters, rootState, rootGetters) => (id, sections) => {
    let batchInfo = {
      name: '',
      batchNo: '',
      data: [],
      status: '',
      exportType: ''
    }
    if (id === 1) {
      batchInfo.name = 'Imported'
      batchInfo.batchNo = sectionIDs.IMPORTED
      batchInfo.data = sections.imported
      batchInfo.status = paymentStatus.PROCESSING
      batchInfo.exportType = state.exportTypes.CO
    } else if (id === 2) {
      batchInfo.name = 'Batch 1'
      batchInfo.batchNo = sectionIDs.BATCH_ONE
      batchInfo.data = sections.batchOne
      batchInfo.status = paymentStatus.PROCESSING
      batchInfo.exportType = state.exportTypes.CO
    } else if (id === 3) {
      batchInfo.name = 'Batch 2'
      batchInfo.batchNo = sectionIDs.BATCH_TWO
      batchInfo.data = sections.batchTwo
      batchInfo.status = paymentStatus.PROCESSING
      batchInfo.exportType = state.exportTypes.CO
    } else if (id === 4) {
      batchInfo.name = 'Approval by Finance'
      batchInfo.batchNo = sectionIDs.APPROVAL_FINANCE
      batchInfo.data = sections.approvalFinance
      batchInfo.status = paymentStatus.APPROVAL_FINANCE
      batchInfo.exportType = state.exportTypes.CO
    } else if (id === 6) {
      batchInfo.name = 'WIP by Finance'
      batchInfo.batchNo = sectionIDs.WIP_FINANCE
      batchInfo.data = sections.partiallyPaid
      batchInfo.status = paymentStatus.PARTIAL
      batchInfo.exportType = state.exportTypes.FINANCE
    } else if (id === 7) {
      batchInfo.name = 'Paid'
      batchInfo.batchNo = sectionIDs.PAID
      batchInfo.data = sections.completed
      batchInfo.status = paymentStatus.PAID
      batchInfo.exportType = state.exportTypes.FINANCE
    }
    return batchInfo
  },
  checkBatch: (state) => (date) => {
    if (!date) return null;
    let day = moment(date).format('D')
    if (day <= 15) {
      return sectionIDs.BATCH_ONE
    }
    if (day > 15) {
      return sectionIDs.BATCH_TWO
    }
    return null
  },
  searchParams: (state) => () => {
    return Object.assign({}, {
      search: '',
      workingSearch: '',
      searchliveDateMonth: '',
      searchDueDateMonth: '',
      searchPaymentDateMonth: '',
      selectedMonth: '',
      liveDatePicker: false,
      dueDatePicker: false,
      paymentStatus: paymentStatus.NEW,
      imported: false,
      country: 'All Country',
      cc: ''
    })
  },
  setDefaultEditFields: (state) => (obj) => {
    obj.swiftCodeEdit = false;
    obj.bankAccountEdit = false;
    obj.usernameEdit = false;
    obj.paymentDateEdit = false;
    obj.bankReferenceEdit = false;
    obj.paymentStatusEdit = false;
    obj.PVNumberEdit = false;
    obj.emailEdit = false;
    obj.bankNameEdit = false;
    obj.countryEdit = false;
    obj.editReport = false;
    return obj;
  },
  getPaidAmount: (state) => (item) => {
    if (item.partialAmount === undefined && item.importedAmount === undefined) {
      return ''
    }
    let totalAmount = 0
    if (item.partialAmount.length > 0) {
      let partials = item.partialAmount
      let amounts = partials.map(p => p.amount)
      totalAmount += amounts.reduce((a, b) => Number(a) + Number(b))
    }
    if (item.importedAmount) {
      totalAmount += item.importedAmount
    }
    return (totalAmount).toFixed(2)
  },
  getSortedLiveDates: (state, getters) => (items) => {
    items = items.map(item => {
      item.formattedLiveDate = ''
      if (item.liveDate) {
        item.formattedLiveDate = utils.func.parseDate(item.liveDate)
      }
      return item
    })
    items = orderBy(items, ['formattedLiveDate'], ['asc'])
    return items
  },
  getRemainAmount: (state, getters) => (item) => {
    let paidAmounts = getters.getPaidAmount(item)
    return (Number(item.amount) - paidAmounts).toFixed(2)
  },
  checkOverDue: (state) => (date) => {
    if (!date) return false;
    let today = moment().format('YYYY-MM-DD')
    return date < today
  },
  checkEarly: (state) => (date) => {
    // if date within next 1 month
    if (!date) return false;
    let today = moment().format('YYYY-MM-DD')
    let oneMonthDate = moment().add(30, 'days').format('YYYY-MM-DD')
    return date > today && date < oneMonthDate
  },
  formatDate: (state) => (date) => {
    if (!date) return null;
    const [year, month, day] = date.split('-');
    let formattedDate = `${day}/${month}/${year}`
    if (formattedDate.includes('undefined')) {
      return date
    }
    return formattedDate;
  }
}

/**
 * actions to implement
*/
const actions = {
    /**
   * get pre-processing payments
   * @param {*} commit
   * @returns
  */
  async getPreProcessingPayments ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'preProcessingPayments',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(paymentServiceBaseURL + `/pre-processing-payments/find?${params}`)
      if (response.data) {
        response = response.data
        response = response.sort((a, b) => {
          let dateA = new Date(a.dueDate)
          let dateB = new Date(b.dueDate)
          return dateB - dateA
        })
        
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'preProcessingPayments',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get imported payments
   * @param {*} commit
   * @returns
  */
  async getImportedPayments ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'importedPayments',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(paymentServiceBaseURL + `/imported-payments/find?${params}`)
      if (response.data) {
        response = response.data
        response = response.sort((a, b) => {
          let dateA = new Date(a.dueDate)
          let dateB = new Date(b.dueDate)
          return dateB - dateA
        })
        
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'importedPayments',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get finance payments
   * @param {*} commit
   * @returns
  */
  async getFinancePayments ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'financePayments',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(paymentServiceBaseURL + `/finance-payments/find?${params}`)
      if (response.data) {
        response = response.data
        response = response.sort((a, b) => {
          let dateA = new Date(a.dueDate)
          let dateB = new Date(b.dueDate)
          return dateB - dateA
        })
        
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'financePayments',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get completed payments
   * @param {*} commit
   * @returns
  */
  async getCompletedPayments ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'completedPayments',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(paymentServiceBaseURL + `/completed-payments/find?${params}`)
      if (response.data) {
        response = response.data
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'completedPayments',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save completed payments
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async saveCompletedPayments ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedCompletedPayments',
        data: false
      })
      await apiService.post(paymentServiceBaseURL + '/completed-payments/create', data)
      commit('SET_DATA', {
        name: 'savedCompletedPayments',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save finance payments
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async saveFinancePayments ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedFinancePayments',
        data: false
      })
      await apiService.post(paymentServiceBaseURL + '/finance-payments/create', data)
      commit('SET_DATA', {
        name: 'savedFinancePayments',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save pre processing payments
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async savePreProcessingPayments ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedPreProcessingPayments',
        data: false
      })
      await apiService.post(paymentServiceBaseURL + '/pre-processing-payments/create', data)
      commit('SET_DATA', {
        name: 'savedPreProcessingPayments',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save imported payments
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async saveImportedPayments ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'saveImportedPayments',
        data: false
      })
      await apiService.post(paymentServiceBaseURL + '/imported-payments/create', data)
      commit('SET_DATA', {
        name: 'saveImportedPayments',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update completed payments by report id
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updateCompletedPaymentsByReportID ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedCompletedPayments',
        data: false
      })
      await apiService.post(paymentServiceBaseURL + '/completed-payments/update-by/reportID', data)
      commit('SET_DATA', {
        name: 'savedCompletedPayments',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get creator cogs estimation
   * @param {*} commit
   * @returns
  */
  async getCreatorCogsEstimate ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'creatorCogsEstimate',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(paymentServiceBaseURL + `/creator-cogs-estimate/find?${params}`)
      if (response.data) {
        response = response.data
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'creatorCogsEstimate',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save creator cogs estimation
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async createCogsEstimate ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'saved',
        data: false
      })
      await apiService.post(paymentServiceBaseURL + '/creator-cogs-estimate/create', data)
      commit('SET_DATA', {
        name: 'saved',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get profit summary
   * @param {*} commit
   * @returns
  */
  async getProfitSummary ({ commit }, payload = {}) {
    try {
      commit('SET_DATA', {
        name: 'profitSummary',
        data: []
      })
      let filters = payload.filters || {}
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      let response = await apiService.get(paymentServiceBaseURL + `/profit-summary/find?${params}`)
      if (response.data) {
        response = response.data
        if (Array.isArray(response) && response.length) {
          commit('SET_DATA', {
            name: 'profitSummary',
            data: response
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },

  async getCurrencyRates({ commit }) {
    try {
      commit('SET_DATA', {
        name: 'currencyRates',
        data: null
      })
      let resp = await apiService.get(paymentServiceBaseURL + '/get/currency-rates')
      if (resp) {
        commit('SET_DATA', {
          name: 'currencyRates',
          data: resp.data
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const mutations = {
  SET_DATA(state, { name, data }) {
    state[name] = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/payment.js